import { CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

const { Text, Title } = Typography;

interface PWARegisterProps {
  children: React.ReactNode;
}

const PWARegister: React.FC<PWARegisterProps> = ({ children }) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [_isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Register service worker
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  setIsUpdateAvailable(true);
                  setShowUpdateModal(true);
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });

      // Handle controller change
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('New service worker activated');
        window.location.reload();
      });
    }
  }, []);

  const handleUpdate = () => {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
    }
    setShowUpdateModal(false);
  };

  const handleDismiss = () => {
    setShowUpdateModal(false);
  };

  return (
    <>
      {children}
      <Modal
        title={
          <Space>
            <ReloadOutlined style={{ color: '#1890ff' }} />
            <Title level={4} style={{ margin: 0 }}>
              Update Available
            </Title>
          </Space>
        }
        open={showUpdateModal}
        onCancel={handleDismiss}
        footer={[
          <Button key='dismiss' onClick={handleDismiss}>
            Dismiss
          </Button>,
          <Button key='update' type='primary' icon={<CheckCircleOutlined />} onClick={handleUpdate}>
            Update Now
          </Button>,
        ]}
        centered
      >
        <Text>
          A new version of HelionData ERP is available. Update now to get the latest features and improvements.
        </Text>
      </Modal>
    </>
  );
};

export default PWARegister;
